import React from "react";
import { ArrowRight, MessageCircleQuestion } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../lib/api";

export const BridgeSection = ({ data }) => (
    <section id="common-questions" className="py-4">
        <Reveal>
            <div className="rounded-[20px] border border-[#E4DFD3] bg-[#F5F2EA] p-7 sm:p-10">
                <div className="flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#DDE5DB] text-[#576856]">
                        <MessageCircleQuestion size={18} strokeWidth={1.6} />
                    </span>
                    <h2 className="font-serif text-2xl sm:text-3xl font-semibold tracking-tight text-[#1A1D1A]">{data.title}</h2>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-[#6D736D]">{data.intro}</p>
                <div className="mt-8 divide-y divide-[#E4DFD3]">
                    {data.items.map((item, i) => (
                        <button
                            key={i}
                            data-testid={`bridge-item-${i + 1}`}
                            onClick={() => scrollToId(item.target)}
                            className="group flex w-full items-center justify-between gap-4 py-5 text-left"
                        >
                            <div>
                                <p className="text-sm sm:text-base font-semibold text-[#1A1D1A]">{item.question}</p>
                                <p className="mt-1 text-xs sm:text-sm text-[#6D736D]">{item.answer}</p>
                            </div>
                            <span className="flex shrink-0 items-center gap-2 text-xs font-bold uppercase tracking-wider text-[#576856]">
                                <span className="hidden sm:inline">{item.link_label}</span>
                                <span className="flex h-8 w-8 items-center justify-center rounded-full border border-[#C4BCA8] bg-white transition-transform duration-300 group-hover:translate-x-1 group-hover:bg-[#576856] group-hover:text-white group-hover:border-[#576856]">
                                    <ArrowRight size={14} strokeWidth={1.8} />
                                </span>
                            </span>
                        </button>
                    ))}
                </div>
            </div>
        </Reveal>
    </section>
);
